export default __webpack_public_path__ + "static/media/plus-icon-grey-bold.8df408f8.svg";